<template>
    <div class="container">
        <online-tabs></online-tabs>
        <div class="bg_fff mt20">
            <online-table :list="list" :showRecord="false"></online-table>
        </div>
    </div>
</template>

<script>
    import OnlineTabs from "../../components/online/tabs";
    import {mapState} from 'vuex'
    import {isEmpty, timeFormat} from "../../lib/utils";
    import {onlineService} from "../../lib/service/online";
    import OnlineTable from "../../components/online/table";

    export default {
        name: "Week",
        data() {
            return {
                list: []
            }
        },
        computed: {
            ...mapState(['currUserBookDoc'])
        },
        components: {OnlineTable, OnlineTabs},
        created() {
            if (isEmpty(this.currUserBookDoc)) {
                this.$router.replace('/main/online');
            } else {
                this.getList();
            }
        },
        methods: {
            async getList() {
                let {currUserBookDoc} = this, now = Date.now(), f = '%Y-%m-%d', delta = 24 * 3600 * 1000;
                const {obj} = await onlineService.list({
                    hosid: currUserBookDoc.bookHosId,
                    ysid: currUserBookDoc.bookDocId,
                    ksid: currUserBookDoc.bookDeptId,
                    //bdate: timeFormat(now + 1 * delta, f),
                    //edate: timeFormat(now + 8 * delta, f)
                });
                if (obj.code === '0') {
                    this.list = obj.list;
                }
            }
        },
    }
</script>

<style scoped>

</style>
